module.exports = __webpack_public_path__ + "img/periodontograma.d2712f89.png";